var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-agreement"},[_c('iframe',{attrs:{"src":"https://api2.ts960.com/sztx/sztx-user.html","frameborder":"0","width":"100%"}})])}]

export { render, staticRenderFns }